import {
  ArrowRightFromBracketSolidIcon,
  BarsSolidIcon,
  DollySolidIcon,
  XMarkSolidIcon,
} from '@app/components/icons'
import Logo from '@app/components/Logo'
import Navigation from '@app/components/Navigation'
import Spacer from '@app/components/Spacer'
import useAuth from '@app/hooks/use-auth.hook'
import ziggy from '@app/utils/ziggy'
import {
  Avatar,
  Button,
  Drawer,
  Flex,
  IconButton,
  Stack,
  Text,
  useDisclosure,
  Separator,
  Portal,
} from '@chakra-ui/react'
import {Link, router} from '@inertiajs/react'
import {useRef} from 'react'

export interface MobileNavigationProps {
  user: User | AgencyMember
}

export default function MobileNavigation({user}: MobileNavigationProps) {
  const {
    open: isNavigationOpen,
    onOpen: onOpenNavigation,
    onClose: onCloseNavigation,
  } = useDisclosure()
  const btnRef = useRef(null)

  const {isAdminDashboard} = useAuth()

  return (
    <>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        backgroundColor="white"
        paddingInline="4"
        height="62px"
        width="full"
      >
        <IconButton
          aria-label="Open menu"
          variant="ghost"
          ref={btnRef}
          onClick={onOpenNavigation}
          fontSize="lg"
        >
          {isNavigationOpen ? <XMarkSolidIcon /> : <BarsSolidIcon />}
        </IconButton>

        <Logo height="12" />
      </Flex>
      <Drawer.Root
        open={isNavigationOpen}
        placement="start"
        size="full"
        finalFocusEl={() => btnRef.current}
        onOpenChange={(e) => {
          if (!e.open) {
            onCloseNavigation()
          }
        }}
      >
        <Portal>
          <Drawer.Backdrop
            style={{
              top: '62px',
            }}
          />
          <Drawer.Positioner>
            <Drawer.Content
              style={{
                top: '62px',
              }}
              paddingBlock="4"
            >
              <Drawer.Title srOnly>Navegación</Drawer.Title>
              <Drawer.Body paddingBlock="0" paddingInline="6">
                <Stack
                  backgroundColor="white"
                  paddingInline="4"
                  paddingBlock="4"
                  border="1px solid"
                  borderColor="gray.200"
                  rounded="xl"
                >
                  <Flex gap="4" paddingInline="2">
                    <Avatar.Root>
                      <Avatar.Fallback name={user.name} />
                    </Avatar.Root>

                    <Stack gap="0" flex="1">
                      <Text fontSize="sm" fontWeight="semibold">
                        {user.name}
                      </Text>
                      <Text fontSize="xs" color="gray.500">
                        {user.email}
                      </Text>
                    </Stack>
                  </Flex>

                  <Separator />

                  <Button
                    aria-label="cerrar sesión"
                    variant="ghost"
                    paddingInline="2"
                    paddingBlock="4"
                    gap="4"
                    color="gray.900"
                    justifyContent="flex-start"
                    fontSize="sm"
                    asChild
                  >
                    <Link href={ziggy('pickup-orders.index')}>
                      <Flex alignItems="center" gap="4">
                        <DollySolidIcon color="brand" />
                        <Text>Vista de bodega</Text>
                      </Flex>
                    </Link>
                  </Button>
                  <Button
                    aria-label="cerrar sesión"
                    variant="ghost"
                    paddingInline="2"
                    paddingBlock="4"
                    gap="4"
                    color="gray.900"
                    justifyContent="flex-start"
                    fontSize="sm"
                    onClick={() => {
                      router.delete(
                        ziggy(
                          isAdminDashboard ? 'admin.logout' : 'agency.logout',
                        ),
                      )
                    }}
                  >
                    <ArrowRightFromBracketSolidIcon color="brand" />
                    Cerrar Sesión
                  </Button>
                </Stack>

                <Spacer height="4" />
                <Navigation onSelected={onCloseNavigation} />
              </Drawer.Body>
            </Drawer.Content>
          </Drawer.Positioner>
        </Portal>
      </Drawer.Root>
    </>
  )
}
